import "./Dropdown.scss";
import { useClickAway, useToggle } from "react-use";
import { useRef } from "react";

function Dropdown({ button, children, closeOnClick = false, isAd = false, isCampaign = false, isMobile = false }) {
  const ref = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useToggle(false);

  useClickAway(ref, () => {
    setDropdownOpen(false);
  });

  const handleContentClick = () => {
    if (closeOnClick) setDropdownOpen(false);
  };

  const getDropdownStyles = () => {
    if (isAd) {
      return { width: "300px", right: -50 };
    }
    if (isCampaign) {
      return { width: "300px", right: -50 };
    }
    return { width: "100%" };
  };

  return (
    <div className="Dropdown" ref={ref}>
      <button className="Dropdown-button" type="button" onClick={setDropdownOpen}>
        {button}
      </button>

      {isDropdownOpen && (
        <div style={isMobile ? { width: "100%" } : getDropdownStyles()} className="Dropdown-content" onClick={handleContentClick}>
          {children}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
